import http from 'axios';
import store from './store';
import router from './router';
import { registerCancelSource, cancelPendingRequests } from './libs/requestCancellation';
import { isInactive, recordActivity, readLastActivity } from './libs/sessionActivity';

const redirectToSignIn = () => {
  if (router.currentRoute.path === '/sign_in') return; // 重複遷移ガード
  router.push({ path: '/sign_in', query: { redirectTo: router.currentRoute.path } });
};

// 無操作経過していればログアウトする。ログアウトしたら true。
// 二重実行・複数タブ競合対策として、ログイン中のみ動作し localStorage を直読みする。
const enforceInactivityLogout = () => {
  if (!store.getters.isSignedIn) return false;
  if (isInactive(readLastActivity(), Date.now())) {
    store.dispatch('signOut');
    redirectToSignIn();
    return true;
  }
  return false;
};

const logoutOn401 = () => {
  const AUTH_ENDPOINTS = ['/api/signin', '/api/verify_otp'];

  http.interceptors.response.use(_ => _, (error) => {
    if (error.response && error.response.status === 401) {
      const isAuthEndpoint = error.config && AUTH_ENDPOINTS.includes(error.config.url);
      if (!isAuthEndpoint) {
        // TODO: Show logout reason
        store.dispatch('signOut');
        redirectToSignIn();
      }
    }
    return Promise.reject(error);
  });
};

export default (Vue) => {
  http.interceptors.request.use((config) => {
    if (config.url.startsWith('/api/') && store.getters.isSignedIn) {
      // ユーザー起因リクエストのみ無操作判定の対象とする
      if (!config.isBackgroundRequest) {
        if (enforceInactivityLogout()) {
          return Promise.reject(new http.Cancel('Session inactive timeout'));
        }
        recordActivity();
      }
      // Add Access token to API requests if logged in
      config.headers.Authorization = `Bearer ${store.getters.getAccessToken}`;
    }
    if (!config.cancelToken) {
      const source = http.CancelToken.source();
      config.cancelToken = source.token;
      registerCancelSource(source);
    }
    if (store.getters.assumedUser) {
      config.headers['assumed-user-id'] = store.getters.assumedUser.id;
    }
    return config;
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      enforceInactivityLogout();
    }
  });

  router.beforeEach((to, from, next) => {
    cancelPendingRequests();
    next();
  });

  logoutOn401();

  Object.defineProperties(Vue.prototype, {
    $http: {
      get() {
        return http;
      },
    },
  });
  Vue.http = http;
};
